// extracted by mini-css-extract-plugin
module.exports =  {"QuickSettings":"gjqDo5xC0g2sbKf7__f2","QuickSettings__Heading":"LRwFGzpZ5Ys4jVgAyJcZ","MultistreamForm":"RvBzXtsL_Uw6Q2F8j9Ym","Checkbox":"Cn98sYtx0hHorng36B1T"};